var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgIconRequirementAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FE768D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.375 7.961 1.855 1.854a1 1 0 1 1-1.415 1.415L7.961 9.375 6.107 11.23a1 1 0 1 1-1.414-1.415l1.854-1.854-1.854-1.854a1 1 0 0 1 1.414-1.414l1.854 1.854 1.854-1.854a1 1 0 0 1 1.415 1.414z"
}))));
export { SvgImgIconRequirementAlert as ReactComponent };
export default __webpack_public_path__ + "img/img-icon-requirement-alert.dfd1d6920814bba10a0f93f2ddef9059.svg";